// material-ui
import {} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Grid } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import * as models from 'models'
import { gridSpacing } from 'store/constant'
import TitleService from 'title-service'
import SubCard from 'ui-component/cards/SubCard'

import { ResourcePropertyType } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import MediaResourcesComponent from 'components/MediaResourcesComponent'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_processMediaFix } from 'features/processMediaFix/processMediaFix-slice'
import { get_selected_processedMedia } from 'features/processedMedia/processedMedia-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let processedMedia = useSelector(get_selected_processedMedia)
  let processMediaFix_list = useSelector(get_all_processMediaFix)
  const [mediaFilter, setMediaFilter] = React.useState(null)
  const [processedMediaId, setProcessedMediaId] = React.useState(null)
  const [stateId, setStateId] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_all_media_resources({ playerId: claims?.player }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && processedMedia?.id) {
      dispatch(
        autoThunks.get_media_connected_to_processed({
          playerId: claims?.player,
          processedMediaId: (() => {
            function get_processedMediaId(): string {
              return processedMedia?.id
            }
            return get_processedMediaId()
          })(),
          mediaId: (() => {
            function get_processedMediaId(): string {
              return processedMedia?.mediaId
            }
            return get_processedMediaId()
          })(),
        }),
      )
    }
  }, [claims?.player, processedMedia?.id])
  useEffect(() => {
    if (claims?.player && processedMediaId) {
      dispatch(
        autoThunks.get_media_fixes_for_processed_media({
          playerId: claims?.player,
          processedMediaId: (() => {
            function get_processedMediaId(): any {
              return processedMediaId
            }
            return get_processedMediaId()
          })(),
        }),
      )
    }
  }, [claims?.player, processedMediaId])
  useEffect(() => {
    if (claims?.player && processedMedia?.id && stateId) {
      dispatch(
        autoThunks.add_media_fix_to_processed_media_state({
          playerId: claims?.player,
          processedMediaId: (() => {
            function getprocessedMediaId(): any {
              return processedMedia?.id
            }
            return getprocessedMediaId()
          })(),
          stateId: (() => {
            function getstateId(): any {
              return stateId
            }
            return getstateId()
          })(),
        }),
      )
    }
  }, [claims?.player, processedMedia?.id, stateId])
  useEffect(() => {
    if (claims?.player && processedMedia?.id) {
      dispatch(autoThunks.get_all_coherentScreens({ playerId: claims?.player }))
    }
  }, [claims?.player, processedMedia?.id])
  useEffect(() => {
    if (claims?.player && processedMedia?.id) {
      dispatch(autoThunks.get_all_curated_media({ playerId: claims?.player }))
    }
  }, [claims?.player, processedMedia?.id])

  function getFixForProcessedMedia(
    processedMediaId: string,
    stateId: string,
  ): any {
    return processMediaFix_list.find(
      (x) =>
        x.stateMediaId === stateId &&
        x.processedMediaId === processedMediaId &&
        !x.deleted,
    )
  }

  function series_media_forms(): any {
    return (function () {
      let titleStyle = {
        right: 0,
        top: 0,
        color: 'black',
        fontSize: 24,
        padding: 10,
      }
      if (!processedMedia) {
        return <></>
      }
      let imageFunc = (
        thumbnail: models.ProcessedMediaStates,
        index: number,
      ) => {
        return (
          <div
            key={index}
            style={{ flex: 1, display: 'flex', flexDirection: 'row' }}
          >
            <div style={{ flex: 1, position: 'relative' }}>
              {!getFixForProcessedMedia(processedMedia?.id, thumbnail.id) && (
                <div style={{ position: 'absolute', zIndex: 10, left: 0 }}>
                  <Grid item>
                    <RedQuickAlert
                      button={
                        <Button
                          variant="contained"
                          sx={{
                            background: theme.palette.error.main,
                            '&:hover': { background: theme.palette.error.dark },
                          }}
                          onClick={async () => {}}
                        >
                          {TitleService('Re-process')}
                        </Button>
                      }
                      cancelText={TitleService('No')}
                      affirmativeText={TitleService('Yes')}
                      onOk={async () => {
                        setStateId(thumbnail?.id)
                      }}
                      title={TitleService('Are you sure?')}
                      description={TitleService(
                        'This is a system wide change.',
                      )}
                    />
                  </Grid>
                </div>
              )}
              <rq.RedQuickTag
                title={<div style={titleStyle}>width: {thumbnail.width}</div>}
              >
                <rq.RedQuickImage
                  style={{ maxWidth: '100%' }}
                  title={'Location'}
                  src={thumbnail.location}
                />
              </rq.RedQuickTag>
            </div>
            <div style={{ flex: 1 }}>
              <rq.RedQuickImage
                style={{ maxWidth: '100%' }}
                title={'Source Url'}
                src={thumbnail.sourceUrl}
              />
            </div>
          </div>
        )
      }
      let movieFunc = (
        thumbnail: models.ProcessedMediaStates,
        index: number,
      ) => {
        return (
          <div
            key={index}
            style={{ flex: 1, display: 'flex', flexDirection: 'row' }}
          >
            <div style={{ flex: 1, position: 'relative' }}>
              {!getFixForProcessedMedia(processedMedia?.id, thumbnail.id) && (
                <div style={{ position: 'absolute', zIndex: 10, left: 0 }}>
                  <Grid item>
                    <RedQuickAlert
                      button={
                        <Button
                          variant="contained"
                          sx={{
                            background: theme.palette.error.main,
                            '&:hover': { background: theme.palette.error.dark },
                          }}
                          onClick={async () => {}}
                        >
                          {TitleService('Re-process')}
                        </Button>
                      }
                      cancelText={TitleService('No')}
                      affirmativeText={TitleService('Yes')}
                      onOk={async () => {
                        setStateId(thumbnail?.id)
                      }}
                      title={TitleService('Are you sure?')}
                      description={TitleService(
                        'This is a system wide change.',
                      )}
                    />
                  </Grid>
                </div>
              )}
              <rq.RedQuickTag
                title={<div style={titleStyle}>width: {thumbnail.width}</div>}
              >
                <rq.RedQuickMovie
                  style={{ maxWidth: '100%' }}
                  title={'Location'}
                  src={thumbnail.location}
                />
              </rq.RedQuickTag>
            </div>
            <div style={{ flex: 1 }}>
              <rq.RedQuickMovie
                style={{ maxWidth: '100%' }}
                title={'Source Url'}
                src={thumbnail.sourceUrl}
              />
            </div>
          </div>
        )
      }
      let titleTransparentUrl = processedMedia.states
        .filter(
          (x) =>
            x.resourcePropertyType === ResourcePropertyType.TitleTransparentUrl,
        )
        .map(imageFunc)
      let titleMediaUrl = processedMedia.states
        .filter(
          (x) => x.resourcePropertyType === ResourcePropertyType.TitleMediaUrl,
        )
        .map(imageFunc)
      let titleMediaImageUrl = processedMedia.states
        .filter(
          (x) =>
            x.resourcePropertyType === ResourcePropertyType.TitleMediaImageUrl,
        )
        .map(imageFunc)
      let thumbnails = processedMedia.states
        .filter(
          (x) => x.resourcePropertyType === ResourcePropertyType.Thumbnail,
        )
        .map(imageFunc)
      let transparentTitleUrl = processedMedia.states
        .filter(
          (x) =>
            x.resourcePropertyType === ResourcePropertyType.TransparentTitleUrl,
        )
        .map(imageFunc)
      let mediaRels = processedMedia.states
        .filter((x) => x.resourcePropertyType === ResourcePropertyType.MediaRel)
        .map(movieFunc)
      let mediaPreviewUrl = processedMedia.states
        .filter(
          (x) =>
            x.resourcePropertyType === ResourcePropertyType.MediaPreviewUrl,
        )
        .map(movieFunc)
      return (
        <>
          <SubCard title={TitleService('Resources')}>
            <Grid
              sx={{
                maxHeight: 'calc(72vw)',
                overflow: 'auto',
              }}
              container
              spacing={gridSpacing}
            >
              {thumbnails.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('Thumbnails')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {thumbnails}
              </Grid>
              {mediaPreviewUrl.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('MediaPreviewUrl')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {mediaPreviewUrl}
              </Grid>
              {mediaRels.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('MediaRel')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {mediaRels}
              </Grid>
              {titleMediaUrl?.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('TitleMediaUrl')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {titleMediaUrl}
              </Grid>
              {titleMediaImageUrl?.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('TitleMediaImageUrl')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {titleMediaImageUrl}
              </Grid>
              {titleTransparentUrl.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('TitleTransparentUrl')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {titleTransparentUrl}
              </Grid>
              {transparentTitleUrl.length && (
                <Grid item xs={12}>
                  <h1>{TitleService('TransparentTitleUrl')}</h1>
                </Grid>
              )}
              <Grid item xs={12}>
                {transparentTitleUrl}
              </Grid>
            </Grid>
          </SubCard>
        </>
      )
    })()
  }

  let output_series_media_forms = series_media_forms()

  function grid(child1: any): any {
    return (() => {
      return <MediaResourcesComponent>{child1}</MediaResourcesComponent>
    })()
  }

  let output_grid = grid(output_series_media_forms)

  return output_grid
}
